/*
 * @Descripttion: AI 模型配置异步请求（page/detail/save/update/enable/delete）
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2026-10-29 10:00:00
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import * as T from './ModelListService'

/** 模型配置列表 */
export const getAIModelPageAsync = createAsyncThunk<
  any,
  T.AIModelPageParams | undefined,
  RootThunkApi
>('AIModel/getAIModelPageAsync', async (params, api) => {
  return sendAsync(T.AIModelPage(params), api)
})

/** 模型配置详情（编辑回显） */
export const getAIModelDetailAsync = createAsyncThunk<
  any,
  T.AIModelDetailParams,
  RootThunkApi
>('AIModel/getAIModelDetailAsync', async (params, api) => {
  return sendAsync(T.AIModelDetail(params), api)
})

/** 新增模型配置 */
export const saveAIModelAsync = createAsyncThunk<
  any,
  T.AIModelParams,
  RootThunkApi
>('AIModel/saveAIModelAsync', async (params, api) => {
  return sendAsync(T.AIModelSave(params), api)
})

/** 修改模型配置 */
export const updateAIModelAsync = createAsyncThunk<
  any,
  T.AIModelParams,
  RootThunkApi
>('AIModel/updateAIModelAsync', async (params, api) => {
  return sendAsync(T.AIModelUpdate(params), api)
})

/** 启用 / 停用 */
export const enableAIModelAsync = createAsyncThunk<
  any,
  T.AIModelEnableParams,
  RootThunkApi
>('AIModel/enableAIModelAsync', async (params, api) => {
  return sendAsync(T.AIModelEnable(params), api)
})

/** 删除 */
export const deleteAIModelAsync = createAsyncThunk<
  any,
  T.AIModelDeleteParams,
  RootThunkApi
>('AIModel/deleteAIModelAsync', async (params, api) => {
  return sendAsync(T.AIModelDelete(params), api)
})
